<template>
  <v-pagination :color="$_colors.primarybackground" v-bind="$attrs" v-on="$listeners" />
</template>

<script>
export default {
  name: 'BasePagination',
};
</script>

<style scoped>
@reference '@/tailwind.css';
/* Reworked pagination */
:deep(.v-pagination button) {
  height: 25px !important;
  width: 25px !important;
  min-width: 0;
  padding: 0 !important;
}
:deep(.v-pagination__navigation) {
  @apply tw:text-xs tw:shadow-none;
}
:deep(.v-pagination__item) {
  @apply tw:text-xs tw:shadow-none;
}
:deep(.v-pagination__navigation:hover) {
  @apply tw:bg-gray-100;
}
:deep(.v-pagination__item:not(.v-pagination__item--active):hover) {
  @apply tw:bg-gray-100;
}

:deep(.v-pagination__item--active) {
  @apply tw:text-primary tw:bg-primarybackground;
}

:deep(.v-pagination__navigation .v-icon) {
  font-size: 16px !important;
}
</style>
